export const additionalData = {
  additionalPhoneOwner: {
    value: 'MyNumber',
    label: 'Мой номер',
    data: {
      alias: 'MyNumber',
    },
  },
  snils: '116-973-38589',
  additionalPhone: '79991237213',
  propertyTypeAvailabilityToggleEnabled: true,
  propertyTypeAvailability: {
    value: 'Flat',
    label: 'Квартира',
    data: {
      alias: 'Flat',
    },
  },
  carAvailability: {
    value: 'No',
    label: 'Нет',
    data: {
      alias: 'No',
    },
  },
  carAvailabilityToggleEnabled: false,
  numberOfDependents: {
    value: 'None',
    label: 'Нет',
    data: {
      alias: 'None',
    },
  },
  maritalStatus: {
    value: 'Single',
    label: 'Холост/не замужем',
    data: {
      alias: 'Single',
    },
  },
  education: {
    value: 'Higher',
    label: 'Высшее',
    data: {
      alias: 'Higher',
    },
  },
};
